import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Box, Divider, Fab, Grid, Paper, Skeleton, Stack, Tooltip, Typography } from '@mui/material'


//import KeyAreaNavBar from "../partials/personalreport/KeyAreaNavBar";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"

import { useReactToPrint } from "react-to-print";
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import WarningIcon from '@mui/icons-material/Warning';
import DangerousIcon from '@mui/icons-material/Dangerous';
import HelpIcon from '@mui/icons-material/Help';
import InfoIcon from '@mui/icons-material/Info';


const motionVariants = {
    hidden: { opacity: 0, x: 0, y: 0 },
    show: {
        opacity: 1, x: 0, y: 0,
        transition: {
            delay: 0.1,
            duration: 0.5,
        }
    }
}

const PersonalReportCallouts = (props) => {
    const { component } = props
    const Callouts = component.ComponentContent.CallOuts
    const Callout1Visible = Callouts.CallOut01.Visible
    const Callout2Visible = Callouts.CallOut02.Visible
    const { settings, PrintView } = props.otherprops
    const GetIcon = ({ valuegrade }) => {
        if (valuegrade == "1") return <HealthAndSafetyIcon sx={{ color: '#4eb748', fontSize:"50px" }} />
        if (valuegrade == "2") return <WarningIcon sx={{ color: '#E7C61E', fontSize:"50px" }} />
        if (valuegrade == "3") return <DangerousIcon sx={{ color: '#9A3218', fontSize:"50px" }} />
        else return <InfoIcon sx={{ color: '#c0c0c0', fontSize:"50px" }} />
    }
    // component will have an array

    // BiometricsArray
    // this array containes n number of elements
    /*
        {
            "GoalValue": "18.5-24.9 kg/m<sup>2</sup>",
            "Score": "40",
            "Order": "10",
            "HelpText": "Body mass index (BMI) is a measure of body fat based on height and weight.",
            "YouValue": "27.7",
            "Label": "BMI",
            "ValueGrade": "2",
            "Visible": "1"
        }
    */
  
    const CalloutCard = ({ obj }) => {

        return (
            <motion.div variants={PrintView === true ? { hidden: { opacity: 1 } } : motionVariants} initial="hidden" animate="show" style={{ height: '100%' }}>
                <Paper elevation={1} sx={{ padding: '20px', width: '100%', height: "100%" }}>
                    <Grid container direction="row" spacing={2} alignItems="top" height={"100%"}>
                   
                        <Grid item xs={12}>
                            <Typography variant="body1" align="center">{obj.PrimaryText}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="h3" align="center" fontWeight={"bold"}>{obj.CalloutText}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body2" align="center">{obj.SecondaryText}</Typography>
                        </Grid>
                    </Grid>
                </Paper>
            </motion.div>
        )
    }

   
    return (
        // <Grid item lg={12} md={12} sm={12} xs={12} justifyContent="center" alignItems="center" sx={{ padding: '10px' }}>
        //     <motion.div variants={PrintView === true ? { hidden: { opacity: 1 } } : motionVariants} initial="hidden" animate="show" style={{ height: '100%' }}>
        //         <Paper elevation={1} sx={{ padding: '20px', height: '40vh', width: '100%' }}>
        //             <KeyAreaGraph graph={component} />
        //         </Paper>
        //     </motion.div>
        // </Grid>
        <Grid item xs={12}>
           
                <Grid container direction={"row"} spacing={2} alignItems="center" justifyContent={"center"}>
                    {/* <Grid item xs={12}>
                        <Typography variant="h3">{component.Label}</Typography>
                    </Grid> */}
                    {Callout1Visible &&(

                        <Grid item xs={12} md={ 6}>
                        <CalloutCard obj={Callouts.CallOut01} />
                    </Grid>
                        )}
                    {Callout2Visible &&(
                        <Grid item xs={12} md={6 }>
                        <CalloutCard obj={Callouts.CallOut02} />
                    </Grid>
                    )}
            
                </Grid>
        
        </Grid>


    )

}
export default PersonalReportCallouts